/* tslint:disable */
/* eslint-disable */
export enum WorkProjectAnlageTypesEnum {
  Aufdach = 'Aufdach',
  Indach = 'Indach',
  Flachdach = 'Flachdach',
  Fassade = 'Fassade'
}
